import { ecId, handBack, upper, type JanusCtx } from '../ability/context.js';
import { revealAfterAction } from '../ability/stealth-hide.js';
import { geometryStatusBefore } from '../geometry/relocation-inputs.js';
import { statusField } from '../../encounter-map/ft3d/perception.js';
import type { StealthWalkEffects, StealthWalkPlan, StealthWalkEvidence } from './stealth-walk.js';

/** Public reveals share the move's log group; each GM prompt keeps its separate identity. */
export function bindStealthRevealLog(evidence: StealthWalkEvidence, operationId: string): StealthWalkEvidence {
  return evidence.effects ? { ...evidence, effects: { ...evidence.effects,
    rows: evidence.effects.rows.map(r => r.kind === 'reveal' ? { ...r, roll_id: upper(operationId) } : r) } } : evidence;
}

/** Every spotted subject loses its temporary Hidden stance for all viewers. */
export function stealthWalkEffects(ctx: JanusCtx, plan: Extract<StealthWalkPlan, { kind: 'resolved' }>,
  campaignSeconds: number | null): StealthWalkEffects {
  const rows: StealthWalkEffects['rows'] = [], lockouts: StealthWalkEffects['lockouts'] = [];
  if (plan.reveals.length && (campaignSeconds === null || !Number.isSafeInteger(campaignSeconds)))
    handBack('stealth:reveal-clock-not-held');
  for (const reveal of plan.reveals) {
    const subject = ctx.members.get(upper(reveal.subject));
    if (!subject) handBack('stealth:reveal-subject-not-held');
    revealAfterAction(ctx, null, null, subject, 'spotted');
    rows.push({ kind: 'reveal', roll_id: ctx.read.uuid(), observer: reveal.observer, subject: reveal.subject, voice: true },
      { kind: 'prompt', roll_id: ctx.read.uuid(), observer: reveal.observer, subject: reveal.subject, voice: false });
    lockouts.push({ target: ecId(subject), stamped: campaignSeconds!, until: campaignSeconds! + 3600 });
  }
  return {
    statusesAdded: ctx.statusesAdded.map(s => ({ ...s, status_id: ctx.read.uuid() })),
    statusesRemoved: ctx.statusesRemoved.map(s => {
      const original = ctx.originals.get(upper(s.target));
      const status = original && ctx.read.statuses(original).find(row => upper(statusField(row, 'status_id')) === upper(s.status_id));
      if (!status) handBack('stealth:removed-status-not-held');
      return { ...s, before: geometryStatusBefore(status) };
    }), rows, lockouts,
  };
}
